import { Injectable, OnInit } from '@angular/core'
//import { ActivatedRoute, NavigationEnd, Params, Router, RouterLink } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs';
//import { MyCustomHttpLoader } from './TranslateService';

@Injectable()
export class RouteDataService  {
  //  routeAttribute: any =''
    
   public activeRoute$ = new BehaviorSubject<string>("default");
   currentRoute$: Observable<string>;


    constructor(
       // public router: Router,
       // private route: ActivatedRoute,
        //public myservice: MyCustomHttpLoader
    ) {

        this.currentRoute$ = this.activeRoute$.asObservable()


       /*  this.router.events.subscribe((e) => {
            if (e instanceof NavigationEnd) {
                //  console.log('Header Path: ' + e.url);
                console.log('ROUTERLOG:' + e.url);
                switch (true) {
                    case e.url.indexOf('hsfs') > -1:
                        this.routeAttribute = 'hsfs'
                        break;
                    default:
                        this.routeAttribute = 'default'
                        break;
                }
            }
        }); */
   }

updateRoute(route: string){
    this.activeRoute$.next(route)
}

  //  getUserGroup(){
          /*      this.route.queryParams.forEach((params: Params) => {
                 console.log('PARAMS' + JSON.stringify(params));
            }) */
           // console.log('EVENTROUTE:' + this.router.url);
           
           // return this.router.url;
            /* this.activeRoute$.subscribe((res :any) => {
                console.log('EVENTROUTE66:' + this.router.url);
              
                switch (true) {
                    case res.indexOf('hsfs') > -1:
                        console.log('CAP:' + res);
                        return 'hsfs'
                    default:
                        return "default"
                }
              })  
                return '' */


     /*          this.router.events.subscribe((e) => {
             if (e instanceof NavigationEnd) {
                //console.log('EVENTROUTE:' + this.router.url);

                 //  console.log('Header Path: ' + e.url);
                 console.log('ROUTERLOG:' + e.url);
                 switch (true) {
                     case e.url.indexOf('hsfs') > -1:
                         return 'hsfs'
                     default:
                         return "default"
                 }
             }
         }); */  
      // return 'default'
        /*    switch (this.routeAttribute) {
            case "hsfs":
                console.log('EVENTROUTE:' + 'hsfs');
                return "hsfs"
            default:
                console.log('EVENTROUTE:' + 'default');
                return "default"
        }  */
   // }

}